import { render, staticRenderFns } from "./ModalInfoCourse.vue?vue&type=template&id=640a6543&scoped=true"
import script from "./ModalInfoCourse.vue?vue&type=script&lang=js"
export * from "./ModalInfoCourse.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoCourse.vue?vue&type=style&index=0&id=640a6543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a6543",
  null
  
)

export default component.exports